module.exports = __webpack_public_path__ + "static/media/telkom-banner-1.5da7d757.png";